import { useMemo } from 'react';

export const shallUseTestMode = () => {
  return (
    globalThis.location.host.includes('localhost') ||
    globalThis.location.host.includes('rtc-widget-frontend.k8s') ||
    globalThis.location.search.includes('rtcForceDev')
  );
};

export const useTestMode = () => {
  const isTestMode = useMemo(() => shallUseTestMode(), []);

  const testArticleId = useMemo(() => {
    if (!isTestMode) {
      return '';
    }

    const urlParams = new URLSearchParams(globalThis.location.search);
    const id = urlParams.get('rtc-test');
    return id?.length === 8 ? id : '29494981';
  }, []);

  return {
    isTestMode,
    testArticleId,
  };
};
